function styleShopifyChat() {
  const chatElement = document.querySelector('#ShopifyChat');
  if (chatElement && chatElement.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
      button.chat-toggle {
        box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 
                    0px 6px 10px 0px rgba(0,0,0,0.14), 
                    0px 1px 18px 0px rgba(0,0,0,0.12) !important;
      }
    `;
    chatElement.shadowRoot.appendChild(style);
  } else {
    // Retry if element not ready yet
    setTimeout(styleShopifyChat, 100);
  }
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', styleShopifyChat);
} else {
  styleShopifyChat();
}